module.exports = require("graceful-fs");